import axios from '@/libs/axios';

const COMMONS_STORAGE_VERSION = '2';
const COMMONS_STORAGE_VERSION_KEY = 'commonsStorageVersion';

const Resource = {
    countries : 'countries',
    genders : 'genders',
    leagues : 'leagues',
    registrationTypes : 'registrationTypes',
    registrationTaxes : 'registrationTaxes',
    ageCategories : 'ageCategories',
    ageCategoryGroups : 'ageCategoryGroups',
    playerStatuses: 'playerStatuses',
    roles: 'roles',
    seasons: 'seasons',
    zips: 'zips',
    dos: 'dos',
}

function clearStoredResources() {
    Object.values(Resource).forEach((resource) => {
        sessionStorage.removeItem(resource);
    });
}

function syncStoredResources() {
    const storedVersion = localStorage.getItem(COMMONS_STORAGE_VERSION_KEY);

    if (storedVersion !== COMMONS_STORAGE_VERSION) {
        clearStoredResources();
        localStorage.setItem(COMMONS_STORAGE_VERSION_KEY, COMMONS_STORAGE_VERSION);
    }
}

async function getResource(state, r) {
    if(state[r].length === 0) {
        try {
            const resourceData = (await axios.get('/auth/commons/'+r)).data || null;

            if(resourceData !== null) {
                state[r] = resourceData;
                sessionStorage.setItem(r, JSON.stringify(state[r]));
            }
            else {
                state[r] = [];
                sessionStorage.removeItem(r);
            }
        }
        catch(e) {
            console.log(e);
            state[r] = [];
            sessionStorage.removeItem(r);
        }
    }
    return state[r];
}

function getStoredResource(resource) {
    const stored = JSON.parse(sessionStorage.getItem(resource)) || [];

    if (resource === Resource.leagues && stored.some(league => !Object.prototype.hasOwnProperty.call(league, 'league_name'))) {
        sessionStorage.removeItem(resource);
        return [];
    }

    return stored;
}

syncStoredResources();

export default {
    namespaced: true,
    state: {
        [Resource.countries]: getStoredResource(Resource.countries),
        [Resource.genders]: getStoredResource(Resource.genders),
        [Resource.leagues]: getStoredResource(Resource.leagues),
        [Resource.registrationTypes]: getStoredResource(Resource.registrationTypes),
        [Resource.registrationTaxes]: getStoredResource(Resource.registrationTaxes),
        [Resource.ageCategories]: getStoredResource(Resource.ageCategories),
        [Resource.ageCategoryGroups]: getStoredResource(Resource.ageCategoryGroups),
        [Resource.playerStatuses]: getStoredResource(Resource.playerStatuses),
        [Resource.roles]: getStoredResource(Resource.roles),
        [Resource.seasons]: getStoredResource(Resource.seasons),
        [Resource.zips]: getStoredResource(Resource.zips),
        [Resource.dos]: getStoredResource(Resource.dos),
    },
    getters: {
        async countries(state) {
            return await getResource(state, Resource.countries);
        },
        async genders(state) {
            return await getResource(state, Resource.genders);
        },
        async leagues(state) {
            return await getResource(state, Resource.leagues);
        },
        async registrationTypes(state) {
            return await getResource(state, Resource.registrationTypes);
        },
        async registrationTaxes(state) {
            return await getResource(state, Resource.registrationTaxes);
        },
        async ageCategories(state) {
            return await getResource(state, Resource.ageCategories);
        },
        async ageCategoryGroups(state) {
            return await getResource(state, Resource.ageCategoryGroups);
        },
        async playerStatuses(state) {
            return await getResource(state, Resource.playerStatuses);
        },
        async roles(state) {
            return await getResource(state, Resource.roles);
        },
        async seasons(state) {
            return await getResource(state, Resource.seasons);
        },
        async zips(state) {
            return await getResource(state, Resource.zips);
        },
        async dos(state) {
            return await getResource(state, Resource.dos);
        },
    },
    mutations: {
    },
    actions: {
        async getRulesByAgeCategoryId ({getters}, {id, isFinalGame}) {
            let rules;

            try {
                const ageCategory = (await getters.ageCategories).find(ac => ac.id === id);

                rules = {
                    playerLimitCheck: ageCategory.player_limit_check,
                    liberoCheck: ageCategory.libero_check,
                    maxSets: isFinalGame ? 5 : ageCategory.max_sets,
                    setsRequiredToWin: isFinalGame ? 3 : ageCategory.sets_to_win,
                    winSetScore: isFinalGame ? 25 : ageCategory.win_set_score,
                    finalSetScore: isFinalGame ? 15 : ageCategory.final_set_score,
                };
            }
            catch (e) {
                console.error(e);
                rules = {
                    playerLimitCheck: true,
                    liberoCheck: true,
                    maxSets: 5,
                    setsRequiredToWin: 3,
                    winSetScore: 25,
                    finalSetScore: 15,
                };
            }

            return rules;
        },
    },
}
